// src/Views/Throughline.js — Marquee + method steps.
import React from 'react';
import { Eyebrow, Marquee } from '../components/primitives';

const STEPS = [
  { num: '01', label: 'Think',  body: 'Find the real problem. Break it into systems.', accent: 'var(--magenta)' },
  { num: '02', label: 'Decide', body: 'Choose the architecture. Write the spec.',       accent: 'var(--purple)'  },
  { num: '03', label: 'Direct', body: 'AI agents execute. I review and refine.',         accent: 'var(--cyan)'    },
];

const MARQUEE_ITEMS = [
  'BOARD GAMES',
  'CIVIC TECH',
  'COACHING SYSTEMS',
  'COGNITIVE OBSERVATORIES',
  'GAMES INTELLIGENCE',
  'NARRATIVE AI',
  'MOTION GRAPHICS',
];

const Throughline = () => {
  return (
    <>
      <Marquee items={MARQUEE_ITEMS} speed={50} />

      <section id="how" style={{ position: 'relative', padding: '140px 28px 180px', zIndex: 2 }}>
        <div
          className="throughline-grid"
          style={{
            maxWidth: 1080,
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.4fr)',
            gap: 80,
            alignItems: 'start',
          }}
        >
          <div>
            <Eyebrow accent="var(--cyan)">⌬ THE METHOD</Eyebrow>
            <h2
              style={{
                fontFamily: 'var(--f-display)',
                fontSize: 'clamp(36px, 4.5vw, 64px)',
                fontWeight: 600,
                lineHeight: 1.12,
                letterSpacing: '-0.03em',
                margin: 0,
                color: 'var(--ink)',
                paddingBottom: '0.1em',
              }}
            >
              The range is the proof.
              <br />
              <span
                style={{
                  background: 'linear-gradient(90deg, var(--cyan), var(--magenta))',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  fontStyle: 'italic',
                  fontWeight: 400,
                  paddingRight: '0.15em',
                  paddingBottom: '0.05em',
                }}
              >
                The method is what makes the range possible.
              </span>
            </h2>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
            <p style={{ fontFamily: 'var(--f-body)', fontSize: 19, lineHeight: 1.6, color: 'var(--ink-2)', margin: 0 }}>
              Every one of these started the same way: a problem I wanted to understand,
              broken down into systems, then built with AI agents executing my specifications.
            </p>

            <div
              className="method-steps"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                gap: 14,
                fontFamily: 'var(--f-mono)',
              }}
            >
              {STEPS.map((step) => (
                <div
                  key={step.num}
                  style={{
                    position: 'relative',
                    padding: '20px 18px',
                    borderRadius: 16,
                    background: 'rgba(160,102,255,0.04)',
                    border: '1px solid var(--line)',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: -1, left: -1,
                      width: 'calc(100% + 2px)',
                      height: 2,
                      background: step.accent,
                      boxShadow: `0 0 14px ${step.accent}`,
                    }}
                  />
                  <div style={{ fontSize: 11, color: 'var(--ink-3)', letterSpacing: '0.18em', marginBottom: 6 }}>
                    {step.num} / 03
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'var(--ink)',
                      marginBottom: 6,
                      fontFamily: 'var(--f-display)',
                    }}
                  >
                    {step.label}
                  </div>
                  <div style={{ fontSize: 12, lineHeight: 1.5, color: 'var(--ink-2)', fontFamily: 'var(--f-body)' }}>
                    {step.body}
                  </div>
                </div>
              ))}
            </div>

            <div
              style={{
                fontFamily: 'var(--f-mono)',
                fontSize: 13,
                color: 'var(--ink-3)',
                padding: '16px 20px',
                border: '1px dashed var(--line-strong)',
                borderRadius: 12,
                background: 'rgba(255,177,63,0.04)',
              }}
            >
              <span style={{ color: 'var(--magenta)' }}>{'>'}</span> I write zero code.{' '}
              <span style={{ color: 'var(--ink)' }}>I think, decide, and direct.</span>{' '}
              The agents build.
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Throughline;
